import axios from "axios";
import Config from "../../../config";

const v2_actionUpdateGroup = (chatId, data) => axios({
    method: "patch",
    url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/groups/${chatId}`,
    data
});

export default v2_actionUpdateGroup;
